import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  NavbarAdmin,
  Modal,
  Resizer,
} from "../../components/CustomComponent.js";
import Footer from "../../components/FooterAdmin.js";

export default class Tiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      tab: "th",

      data: [],

      uid: "",
      photo: [],
      th_product_name: "", // ชื่อสินค้า
      th_description: "", // รายละเอียดสินค้า
      th_type: "",
      th_stove: "", // ระบบของเตา
      th_size: "", // ขนาด (ประมาณ)
      th_weight: "", // น้ำหนัก (ประมาณ)
      th_amount: "", // ปริมาณที่เผาได้/ ชม.
      th_ratio: "", // อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)
      th_chamber: "", // ห้องเผาไหม้
      th_temperature: "", // อุณหภูมิในขณะเผาไหม้
      th_fuel: "", // เชื้อเพลิงในการเผาไหม้
      th_aeration: "", // ระบบเติมอากาศ
      th_lifespan: "", // อายุการใช้งาน
      th_warranty: "", // การรับประกัน
us_product_name: "",
us_description: "",
us_type: "",
us_stove: "",
us_size: "",
us_weight: "",
us_amount: "",
us_ratio: "",
us_chamber: "",
us_temperature: "",
us_fuel: "",
us_aeration: "",
us_lifespan: "",
us_warranty: "",
us_method: "",
jp_product_name: "",
jp_description: "",
jp_type: "",
jp_stove: "",
jp_size: "",
jp_weight: "",
jp_amount: "",
jp_ratio: "",
jp_chamber: "",
jp_temperature: "",
jp_fuel: "",
jp_aeration: "",
jp_lifespan: "",
jp_warranty: "",
jp_method: "",
cn_product_name: "",
cn_description: "",
cn_type: "",
cn_stove: "",
cn_size: "",
cn_weight: "",
cn_amount: "",
cn_ratio: "",
cn_chamber: "",
cn_temperature: "",
cn_fuel: "",
cn_aeration: "",
cn_lifespan: "",
cn_warranty: "",
cn_method: "",
    };
  }

  async componentDidMount() {
    loading(false);
   if (!profile || profile?.ep < new Date().getTime()) {
         localStorage.removeItem("scp-profile");
         alert(
           "/login",
           "warning",
           "แจ้งเตือน",
           "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
         );
       }else{
         await this.Get();
       }
  }
  Get = async () => {
    loading(true);
    let response = await fetch(
      process.env.REACT_APP_API_URL + `/product.json`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    this.setState({ data: result ? Object.values(result) : [] });
//         const output = Object.fromEntries(
//       Object.values(result).map(e => ([
//         e.uid,
//         {
//           uid: e.uid,
//     photo: e.photo,
//           th_product_name :e.product_name,
//           th_description :e.description,
//           th_type :e.type,
//           th_stove :e.stove,
//           th_size :e.size,
//           th_weight :e.weight,
//           th_amount :e.amount,
//           th_ratio :e.ratio,
//           th_chamber :e.chamber,
//           th_temperature :e.temperature,
//           th_fuel :e.fuel,
//           th_aeration :e.aeration,
//           th_lifespan :e.lifespan,
//           th_warranty :e.warranty,
//           th_method :e.method,
// us_product_name: "",
// us_description: "",
// us_type: "",
// us_stove: "",
// us_size: "",
// us_weight: "",
// us_amount: "",
// us_ratio: "",
// us_chamber: "",
// us_temperature: "",
// us_fuel: "",
// us_aeration: "",
// us_lifespan: "",
// us_warranty: "",
// us_method: "",
// jp_product_name: "",
// jp_description: "",
// jp_type: "",
// jp_stove: "",
// jp_size: "",
// jp_weight: "",
// jp_amount: "",
// jp_ratio: "",
// jp_chamber: "",
// jp_temperature: "",
// jp_fuel: "",
// jp_aeration: "",
// jp_lifespan: "",
// jp_warranty: "",
// jp_method: "",
// cn_product_name: "",
// cn_description: "",
// cn_type: "",
// cn_stove: "",
// cn_size: "",
// cn_weight: "",
// cn_amount: "",
// cn_ratio: "",
// cn_chamber: "",
// cn_temperature: "",
// cn_fuel: "",
// cn_aeration: "",
// cn_lifespan: "",
// cn_warranty: "",
// cn_method: "",
//         }
//       ]))
//     );
//         await fetch(
//           process.env.REACT_APP_API_URL +
//             `/product.json`,
//           {
//             method: "PATCH",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(output)}
//         );
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      uid,
      photo,
     th_product_name,
      th_description,
      th_type,
      th_stove,
      th_size,
      th_weight,
      th_amount,
      th_ratio,
      th_chamber,
      th_temperature,
      th_fuel,
      th_aeration,
      th_lifespan,
      th_warranty,
us_product_name,
us_description,
us_type,
us_stove,
us_size,
us_weight,
us_amount,
us_ratio,
us_chamber,
us_temperature,
us_fuel,
us_aeration,
us_lifespan,
us_warranty,
us_method,
jp_product_name,
jp_description,
jp_type,
jp_stove,
jp_size,
jp_weight,
jp_amount,
jp_ratio,
jp_chamber,
jp_temperature,
jp_fuel,
jp_aeration,
jp_lifespan,
jp_warranty,
jp_method,
cn_product_name,
cn_description,
cn_type,
cn_stove,
cn_size,
cn_weight,
cn_amount,
cn_ratio,
cn_chamber,
cn_temperature,
cn_fuel,
cn_aeration,
cn_lifespan,
cn_warranty,
cn_method,
    } = this.state;
    loading(true);

    let now = new Date().getTime();
    await fetch(
      process.env.REACT_APP_API_URL +
        `/product/${uid || now}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: uid || now,
          photo,
          th_product_name,
      th_description,
      th_type,
      th_stove,
      th_size,
      th_weight,
      th_amount,
      th_ratio,
      th_chamber,
      th_temperature,
      th_fuel,
      th_aeration,
      th_lifespan,
      th_warranty,
us_product_name,
us_description,
us_type,
us_stove,
us_size,
us_weight,
us_amount,
us_ratio,
us_chamber,
us_temperature,
us_fuel,
us_aeration,
us_lifespan,
us_warranty,
us_method,
jp_product_name,
jp_description,
jp_type,
jp_stove,
jp_size,
jp_weight,
jp_amount,
jp_ratio,
jp_chamber,
jp_temperature,
jp_fuel,
jp_aeration,
jp_lifespan,
jp_warranty,
jp_method,
cn_product_name,
cn_description,
cn_type,
cn_stove,
cn_size,
cn_weight,
cn_amount,
cn_ratio,
cn_chamber,
cn_temperature,
cn_fuel,
cn_aeration,
cn_lifespan,
cn_warranty,
cn_method,
        }),
      }
    );

    await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ last_update: new Date().getTime() }),
    });
    alert("#", "success");
    loading(false);
  };
  Delete = async (uid) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบข้อมูลนี้หรือไม่?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      await fetch(process.env.REACT_APP_API_URL + `/product/${uid}.json`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ last_update: new Date().getTime() }),
      });
      alert("#", "success");
      loading(false);
    }
  };

  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      data,
      
      tab,

      photo,
      th_product_name,
      th_description,
      th_type,
      th_stove,
      th_size,
      th_weight,
      th_amount,
      th_ratio,
      th_chamber,
      th_temperature,
      th_fuel,
      th_aeration,
      th_lifespan,
      th_warranty,
us_product_name,
us_description,
us_type,
us_stove,
us_size,
us_weight,
us_amount,
us_ratio,
us_chamber,
us_temperature,
us_fuel,
us_aeration,
us_lifespan,
us_warranty,
us_method,
jp_product_name,
jp_description,
jp_type,
jp_stove,
jp_size,
jp_weight,
jp_amount,
jp_ratio,
jp_chamber,
jp_temperature,
jp_fuel,
jp_aeration,
jp_lifespan,
jp_warranty,
jp_method,
cn_product_name,
cn_description,
cn_type,
cn_stove,
cn_size,
cn_weight,
cn_amount,
cn_ratio,
cn_chamber,
cn_temperature,
cn_fuel,
cn_aeration,
cn_lifespan,
cn_warranty,
cn_method,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <NavbarAdmin />
        <div className="body p-3 mt-3">
          <h4 className="fw-bold mb-4">สินค้า</h4>
          <div className="rounded-3 bg-white p-3 mb-3">
            <h5 className="fw-bold mb-3">
              <span className="icon me-1 text-14">{"\uf0b0"}</span>ฟิลเตอร์
            </h5>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="Search..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-warning px-3 me-2 mb-2"
                  onClick={() => {}}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({ filter_search: "" });
                  }}
                >
                  ล้างข้อมูล
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-dark px-4"
              onClick={() => {
                this.setState({
                  modal_create: true,
                  tab: "th",
                  photo: [],
                  th_product_name: "", // ชื่อสินค้า
      th_description: "", // รายละเอียดสินค้า
      th_type: "",
      th_stove: "", // ระบบของเตา
      th_size: "", // ขนาด (ประมาณ)
      th_weight: "", // น้ำหนัก (ประมาณ)
      th_amount: "", // ปริมาณที่เผาได้/ ชม.
      th_ratio: "", // อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)
      th_chamber: "", // ห้องเผาไหม้
      th_temperature: "", // อุณหภูมิในขณะเผาไหม้
      th_fuel: "", // เชื้อเพลิงในการเผาไหม้
      th_aeration: "", // ระบบเติมอากาศ
      th_lifespan: "", // อายุการใช้งาน
      th_warranty: "", // การรับประกัน
us_product_name: "",
us_description: "",
us_type: "",
us_stove: "",
us_size: "",
us_weight: "",
us_amount: "",
us_ratio: "",
us_chamber: "",
us_temperature: "",
us_fuel: "",
us_aeration: "",
us_lifespan: "",
us_warranty: "",
us_method: "",
jp_product_name: "",
jp_description: "",
jp_type: "",
jp_stove: "",
jp_size: "",
jp_weight: "",
jp_amount: "",
jp_ratio: "",
jp_chamber: "",
jp_temperature: "",
jp_fuel: "",
jp_aeration: "",
jp_lifespan: "",
jp_warranty: "",
jp_method: "",
cn_product_name: "",
cn_description: "",
cn_type: "",
cn_stove: "",
cn_size: "",
cn_weight: "",
cn_amount: "",
cn_ratio: "",
cn_chamber: "",
cn_temperature: "",
cn_fuel: "",
cn_aeration: "",
cn_lifespan: "",
cn_warranty: "",
cn_method: "",
                });
              }}
            >
              สร้างสินค้า
            </button>
          </div>
          <div className="rounded-3 bg-white p-3">
            <div className="table-responsive">
              <table className="table table-hover table-striped-columns">
                <thead>
                  <tr>
                    <td className="wpx-70 text-center">ลำดับ</td>
                    <td>ชื่อสินค้า</td>
                    <td>ประเภท</td>
                    <td className="wpx-80 text-center">จัดการ</td>
                  </tr>
                </thead>
                <tbody>
                  {data
                    ?.filter(
                      (item) =>
                        !filter_search ||
                        item.th_product_name.includes(filter_search)
                    )
                    .map((item, index) => (
                      <tr key={`array-${index}`}>
                        <td className="text-center">
                          {index+1}
                        </td>
                        <td>{item.th_product_name}</td>
                        <td>{item.th_type}</td>
                        <td>
                          <div className="w-100 d-flex justify-content-center">
                            <BtnIcon
                              type="update"
                              onClick={() => {
                                this.setState({ modal_update: true, ...item });
                              }}
                            />
                            <BtnIcon
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
<div className="hpx-40"></div>
                <Footer />
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
          size={"xl"}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create ? "สร้าง" : modal_update ? "แก้ไข" : ""}สินค้า
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
             <div className="d-flex mb-3">
            <div
              className="border-primary rounded-4 d-flex"
              style={{ padding: 2 }}
            >
              <button
                className={`btn btn-${tab === "th" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "th" });
                }}
              >
                ไทย
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "us" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "us" });
                }}
              >
                อังกฤษ
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "jp" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "jp" });
                }}
              >
                ญี่ปุ่น
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "cn" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "cn" });
                }}
              >
                จีน
              </button>
            </div>
          </div>
           <div className="mb-2">
                  <div className="mt-2">รูปภาพ{required}</div>
                  <div className="d-flex flex-wrap">
                    <input
                      hidden
                      accept="image/*"
                      id="image"
                      type="file"
                      onChange={async (e) => {
                        loading(true);
                        const file = e.target.files[0];
                        if (!file) return;

                        const reader = new FileReader();
                        reader.onloadend = async () => {
                          const base64 = reader.result;
                          console.log(base64); // ✅ base64
                          // setState(base64) หรือส่งไป API ได้เลย
                          const formdata = new FormData();
                          formdata.append("image", base64.split(",")[1]);

                          const response = await fetch(
                            "https://api.imgbb.com/1/upload?key=" + process.env.REACT_APP_IMGBB_KEY,
                            {
                              method: "POST",
                              body: formdata,
                            }
                          );

                          const result = await response.json();

                          this.setState({
                            photo: [...photo, result.data.image.url],
                          });
                          loading(false);
                        };
                        reader.readAsDataURL(file);

                        e.target.value = "";
                        e.target.files = null;
                      }}
                    />
                    {photo.length !== 0 && (
                      <div className="d-flex flex-wrap">
                        {photo?.map((item, index) => (
                          <div className="hpx-100 wpx-100 rounded-3 border p-1 position-relative me-3 mb-3">
                            <img
                              alt="example"
                              src={item}
                              className="rounded-3"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <span
                              className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                              style={{ right: -8, top: -8 }}
                              onClick={() => {
                                photo.splice(index, 1);
                                this.setState({ photo });
                              }}
                            >
                              {"\uf00d"}
                            </span>
                          </div>
                        ))}
                        <div
                          className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                          onClick={() => {
                            document.getElementById("image").click();
                          }}
                        >
                          {"\uf03e"}
                        </div>
                      </div>
                    )}
                    {photo.length === 0 && (
                      <div className="d-flex">
                        <div
                          className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                          onClick={() => {
                            document.getElementById("image").click();
                          }}
                        >
                          {"\uf03e"}
                        </div>
                        <small className="text-secondary ps-3">
                          <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล
                          เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                          <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF <br />
                          <b>ขนาดไฟล์สูงสุด:</b> 5MB
                        </small>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <div className="mt-2">ประเภท</div>
                  <select
                    type="text"
                    className="form-control"
                    placeholder="ประเภท.."
                    onChange={(e) => {
                      this.setState({ 
                        th_type: e.target.value,
                        us_type: e.target.value,
                        jp_type: e.target.value,
                        cn_type: e.target.value,
                       });
                    }}
                    value={th_type}
                  >
                    <option value="">--ประเภท--</option>
                    <option value="ใช้พลังงานไฟฟ้าและเชื้อเพลิง">
                      ใช้พลังงานไฟฟ้าและเชื้อเพลิง
                    </option>
                    <option value="ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง">
                      ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง
                    </option>
                  </select>
                </div>
                {tab === "th" && (<div className="row">
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ชื่อสินค้า{required}</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ชื่อสินค้า.."
                    onChange={(e) => {
                      this.setState({ th_product_name: e.target.value });
                    }}
                    value={th_product_name}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">รายละเอียด</div>
                  <textarea
                    className="form-control"
                    placeholder="รายละเอียด.."
                    rows={7}
                    onChange={(e) => {
                      this.setState({ th_description: e.target.value });
                    }}
                    value={th_description}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ระบบของเตา</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบของเตา.."
                    onChange={(e) => {
                      this.setState({ th_stove: e.target.value });
                    }}
                    value={th_stove}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ขนาด</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ขนาด.."
                    onChange={(e) => {
                      this.setState({ th_size: e.target.value });
                    }}
                    value={th_size}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">น้ำหนัก</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="น้ำหนัก.."
                    onChange={(e) => {
                      this.setState({ th_weight: e.target.value });
                    }}
                    value={th_weight}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ปริมาณที่เผาได้/ ชม</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ปริมาณที่เผาได้/ ชม.."
                    onChange={(e) => {
                      this.setState({ th_amount: e.target.value });
                    }}
                    value={th_amount}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">
                    อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง).."
                    onChange={(e) => {
                      this.setState({ th_ratio: e.target.value });
                    }}
                    value={th_ratio}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ห้องเผาไหม้</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ห้องเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ th_chamber: e.target.value });
                    }}
                    value={th_chamber}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อุณหภูมิในขณะเผาไหม้</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อุณหภูมิในขณะเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ th_temperature: e.target.value });
                    }}
                    value={th_temperature}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">เชื้อเพลิงในการเผาไหม้</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="เชื้อเพลิงในการเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ th_fuel: e.target.value });
                    }}
                    value={th_fuel}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ระบบเติมอากาศ</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบเติมอากาศ.."
                    onChange={(e) => {
                      this.setState({ th_aeration: e.target.value });
                    }}
                    value={th_aeration}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อายุการใช้งาน</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อายุการใช้งาน.."
                    onChange={(e) => {
                      this.setState({ th_lifespan: e.target.value });
                    }}
                    value={th_lifespan}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">การรับประกัน</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="การรับประกัน.."
                    onChange={(e) => {
                      this.setState({ th_warranty: e.target.value });
                    }}
                    value={th_warranty}
                  />
                </div>
              </div>
            </div>)}
                {tab === "us" && (<div className="row">
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ชื่อสินค้า{required}(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ชื่อสินค้า.."
                    onChange={(e) => {
                      this.setState({ us_product_name: e.target.value });
                    }}
                    value={us_product_name}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">รายละเอียด(EN)</div>
                  <textarea
                    className="form-control"
                    placeholder="รายละเอียด.."
                    rows={7}
                    onChange={(e) => {
                      this.setState({ us_description: e.target.value });
                    }}
                    value={us_description}
                  />
                </div>

                <div className="mb-3">
                  <div className="mt-2">ระบบของเตา(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบของเตา.."
                    onChange={(e) => {
                      this.setState({ us_stove: e.target.value });
                    }}
                    value={us_stove}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ขนาด(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ขนาด.."
                    onChange={(e) => {
                      this.setState({ us_size: e.target.value });
                    }}
                    value={us_size}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">น้ำหนัก(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="น้ำหนัก.."
                    onChange={(e) => {
                      this.setState({ us_weight: e.target.value });
                    }}
                    value={us_weight}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ปริมาณที่เผาได้/ ชม(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ปริมาณที่เผาได้/ ชม.."
                    onChange={(e) => {
                      this.setState({ us_amount: e.target.value });
                    }}
                    value={us_amount}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">
                    อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)
                  (EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง).."
                    onChange={(e) => {
                      this.setState({ us_ratio: e.target.value });
                    }}
                    value={us_ratio}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ห้องเผาไหม้(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ห้องเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ us_chamber: e.target.value });
                    }}
                    value={us_chamber}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อุณหภูมิในขณะเผาไหม้(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อุณหภูมิในขณะเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ us_temperature: e.target.value });
                    }}
                    value={us_temperature}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">เชื้อเพลิงในการเผาไหม้(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="เชื้อเพลิงในการเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ us_fuel: e.target.value });
                    }}
                    value={us_fuel}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ระบบเติมอากาศ(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบเติมอากาศ.."
                    onChange={(e) => {
                      this.setState({ us_aeration: e.target.value });
                    }}
                    value={us_aeration}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อายุการใช้งาน(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อายุการใช้งาน.."
                    onChange={(e) => {
                      this.setState({ us_lifespan: e.target.value });
                    }}
                    value={us_lifespan}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">การรับประกัน(EN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="การรับประกัน.."
                    onChange={(e) => {
                      this.setState({ us_warranty: e.target.value });
                    }}
                    value={us_warranty}
                  />
                </div>
              </div>
            </div>)}
                {tab === "jp" && (<div className="row">
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ชื่อสินค้า{required}(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ชื่อสินค้า.."
                    onChange={(e) => {
                      this.setState({ jp_product_name: e.target.value });
                    }}
                    value={jp_product_name}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">รายละเอียด(JP)</div>
                  <textarea
                    className="form-control"
                    placeholder="รายละเอียด.."
                    rows={7}
                    onChange={(e) => {
                      this.setState({ jp_description: e.target.value });
                    }}
                    value={jp_description}
                  />
                </div>

                <div className="mb-3">
                  <div className="mt-2">ระบบของเตา(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบของเตา.."
                    onChange={(e) => {
                      this.setState({ jp_stove: e.target.value });
                    }}
                    value={jp_stove}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ขนาด(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ขนาด.."
                    onChange={(e) => {
                      this.setState({ jp_size: e.target.value });
                    }}
                    value={jp_size}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">น้ำหนัก(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="น้ำหนัก.."
                    onChange={(e) => {
                      this.setState({ jp_weight: e.target.value });
                    }}
                    value={jp_weight}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ปริมาณที่เผาได้/ ชม(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ปริมาณที่เผาได้/ ชม.."
                    onChange={(e) => {
                      this.setState({ jp_amount: e.target.value });
                    }}
                    value={jp_amount}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">
                    อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)
                  (JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง).."
                    onChange={(e) => {
                      this.setState({ jp_ratio: e.target.value });
                    }}
                    value={jp_ratio}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ห้องเผาไหม้(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ห้องเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ jp_chamber: e.target.value });
                    }}
                    value={jp_chamber}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อุณหภูมิในขณะเผาไหม้(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อุณหภูมิในขณะเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ jp_temperature: e.target.value });
                    }}
                    value={jp_temperature}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">เชื้อเพลิงในการเผาไหม้(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="เชื้อเพลิงในการเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ jp_fuel: e.target.value });
                    }}
                    value={jp_fuel}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ระบบเติมอากาศ(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบเติมอากาศ.."
                    onChange={(e) => {
                      this.setState({ jp_aeration: e.target.value });
                    }}
                    value={jp_aeration}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อายุการใช้งาน(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อายุการใช้งาน.."
                    onChange={(e) => {
                      this.setState({ jp_lifespan: e.target.value });
                    }}
                    value={jp_lifespan}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">การรับประกัน(JP)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="การรับประกัน.."
                    onChange={(e) => {
                      this.setState({ jp_warranty: e.target.value });
                    }}
                    value={jp_warranty}
                  />
                </div>
              </div>
            </div>)}
                {tab === "cn" && (
                  <div className="row">
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ชื่อสินค้า{required}(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ชื่อสินค้า.."
                    onChange={(e) => {
                      this.setState({ cn_product_name: e.target.value });
                    }}
                    value={cn_product_name}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">รายละเอียด(CN)</div>
                  <textarea
                    className="form-control"
                    placeholder="รายละเอียด.."
                    rows={7}
                    onChange={(e) => {
                      this.setState({ cn_description: e.target.value });
                    }}
                    value={cn_description}
                  />
                </div>

                <div className="mb-3">
                  <div className="mt-2">ระบบของเตา(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบของเตา.."
                    onChange={(e) => {
                      this.setState({ cn_stove: e.target.value });
                    }}
                    value={cn_stove}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ขนาด(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ขนาด.."
                    onChange={(e) => {
                      this.setState({ cn_size: e.target.value });
                    }}
                    value={cn_size}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">น้ำหนัก(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="น้ำหนัก.."
                    onChange={(e) => {
                      this.setState({ cn_weight: e.target.value });
                    }}
                    value={cn_weight}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <div className="mt-2">ปริมาณที่เผาได้/ ชม(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ปริมาณที่เผาได้/ ชม.."
                    onChange={(e) => {
                      this.setState({ cn_amount: e.target.value });
                    }}
                    value={cn_amount}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">
                    อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)
                  (CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง).."
                    onChange={(e) => {
                      this.setState({ cn_ratio: e.target.value });
                    }}
                    value={cn_ratio}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ห้องเผาไหม้(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ห้องเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ cn_chamber: e.target.value });
                    }}
                    value={cn_chamber}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อุณหภูมิในขณะเผาไหม้(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อุณหภูมิในขณะเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ cn_temperature: e.target.value });
                    }}
                    value={cn_temperature}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">เชื้อเพลิงในการเผาไหม้(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="เชื้อเพลิงในการเผาไหม้.."
                    onChange={(e) => {
                      this.setState({ cn_fuel: e.target.value });
                    }}
                    value={cn_fuel}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">ระบบเติมอากาศ(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ระบบเติมอากาศ.."
                    onChange={(e) => {
                      this.setState({ cn_aeration: e.target.value });
                    }}
                    value={cn_aeration}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">อายุการใช้งาน(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="อายุการใช้งาน.."
                    onChange={(e) => {
                      this.setState({ cn_lifespan: e.target.value });
                    }}
                    value={cn_lifespan}
                  />
                </div>
                <div className="mb-3">
                  <div className="mt-2">การรับประกัน(CN)</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="การรับประกัน.."
                    onChange={(e) => {
                      this.setState({ cn_warranty: e.target.value });
                    }}
                    value={cn_warranty}
                  />
                </div>
              </div>
            </div>
                )}
            
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
